import * as React from 'react'
import { Input, Select } from '@mobiscroll/react-latest'
import { DrawingMode } from './StationUserGoinZonePane'
import UIMessages from 'src/utils/ui-messages'

interface IDrawingToolsButtonsProps {
  map: any
  onDrawingToolSelect: (tool: DrawingMode) => void
  drawBy: DrawingMode
  adding: boolean
  address: string
  onLocationAutocompleteChange: (address: any) => void
  onLocationAutocompleteDropdownSelect: (address: any) => void
  loadKmlFile: (file: any) => void
  toAdd: string
}

class DrawingToolsButtons extends React.Component<IDrawingToolsButtonsProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const PlacesAutocompleteContain = require('react-places-autocomplete')
    const PlacesAutocomplete = PlacesAutocompleteContain.default

    const modeOptions = [
      { value: DrawingMode.ZONE, text: 'Draw Geo Zone' },
      { value: DrawingMode.PLACE, text: 'Place - Coming soon!' },
      { value: DrawingMode.CITY, text: 'City' },
      { value: DrawingMode.COUNTY, text: 'County' },
      { value: DrawingMode.STATE, text: 'State' },
      { value: DrawingMode.KMLFILE, text: 'KML File' }
    ]

    const selectedOption = modeOptions.filter(m => m.value === this.props.drawBy)[0]
    const { mode } = UIMessages.common
    const inputProps = {
      inputStyle: 'box' as const,
      labelStyle: 'floating' as const,
      theme: 'ios'
    }

    return (
      <div className='mbsc-row'>
        <div className='mbsc-col-12 mbsc-padding'>
          <Select
            {...inputProps}
            data={modeOptions}
            label={mode}
            value={selectedOption.value}
            onChange={this.handleDrawChange}
          />
        </div>
        {this.props.drawBy !== DrawingMode.ZONE && this.props.drawBy !== DrawingMode.KMLFILE && (
          <div className='mbsc-col-12 pb2'>
            <PlacesAutocomplete
              value={this.props.address}
              onChange={this.props.onLocationAutocompleteChange}
              onSelect={this.props.onLocationAutocompleteDropdownSelect}
              searchOptions={{
                componentRestrictions: {
                  country: 'us'
                },
                location: this.props.map.getCenter(),
                types: this.getLocationAutocompleteType(),
                radius: 2000
              }}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }: any) => (
                <div className='relative'>
                  <Input
                    {...inputProps}
                    {...getInputProps({
                      placeholder: 'Search ' + this.props.drawBy + ' ...',
                      className: 'location-search-input'
                    })}
                    style={{ height: '49px' }}
                  />
                  <div
                    className='autocomplete-dropdown-container absolute w100'
                    style={{ boxShadow: '0px 0px 2px grey', zIndex: 5 }}
                  >
                    {this.filterResults(suggestions, getSuggestionItemProps)}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          </div>
        )}
        {this.props.drawBy === DrawingMode.KMLFILE && (
          <div className='mbsc-col-12 pb2'>
            <Input
              {...inputProps}
              accept='.kml'
              label='File'
              labelStyle='stacked'
              name='kmlfile-input'
              placeholder='Select file ...'
              type='file'
              onChange={this.kmlFileLoad}
            />
          </div>
        )}
      </div>
    )
  }

  private kmlFileLoad = (event: any) => {
    const file = event.target.files[0]
    this.props.loadKmlFile(file)
  }

  private handleDrawChange = (event: any) => {
    let drawMode: DrawingMode = event.value
    if (this.props.toAdd === 'pick up/drop off point' && drawMode === DrawingMode.ZONE) {
      drawMode = DrawingMode.PLACE
    }
    this.props.onDrawingToolSelect(drawMode)
  }

  private getLocationAutocompleteType = () => {
    switch (this.props.drawBy) {
      case DrawingMode.PLACE:
        return ['address']
      case DrawingMode.CITY:
        return ['(cities)']
      case DrawingMode.COUNTY:
        return ['(regions)']
      case DrawingMode.STATE:
        return ['(regions)']

      default:
        return ['(cities)']
    }
  }

  private filterResults = (suggestions: any, getSuggestionItemProps: any) => {
    const hasType = (type: string, lst: any[]) => {
      for (const i of Object.keys(lst)) {
        if (lst[i] === type) {
          return true
        }
      }
      return false
    }
    const realSuggestions: any[] = []
    for (const i of Object.keys(suggestions)) {
      const sug = suggestions[i]
      if (this.props.drawBy === DrawingMode.STATE) {
        if (hasType('administrative_area_level_1', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.COUNTY) {
        if (hasType('administrative_area_level_2', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.CITY) {
        if (hasType('locality', sug.types)) {
          realSuggestions.push(sug)
        }
      }
      if (this.props.drawBy === DrawingMode.PLACE) {
        realSuggestions.push(sug)
      }
    }

    return realSuggestions.map((suggestion: any) => {
      const className = `p1 w100 ${suggestion.active ? 'suggestion-item--active' : 'suggestion-item'}`
      // inline style for demonstration purpose
      const style = suggestion.active
        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
        : { backgroundColor: '#ffffff', cursor: 'pointer' }

      return (
        <div
          key={suggestion}
          {...getSuggestionItemProps(suggestion, {
            className,
            style
          })}
        >
          <span>{suggestion.description}</span>
        </div>
      )
    })
  }
}

export default DrawingToolsButtons



// WEBPACK FOOTER //
// ./src/components/station-user/view/DrawingToolsButtons.tsx